/* eslint-disable no-unused-vars */
import React from 'react';
/* eslint-enable no-unused-vars */

const Header = ({ children, className }) => (
  <header className={className}>
    <div className="content">{children}</div>
  </header>
);

export default Header;
